export type Tenant = {
    primaryColor: string
    integrationType: string
    id: string
    domainName: string
}

export enum IntegrationType {
    CARGOWISE = 'CARGOWISE',
    DESCARTES_ONEVIEW = 'DESCARTES_ONEVIEW',
}
